import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Checkbox, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

interface ConfirmCheckoutInformationProps {
  onChangeTermsAndConditions: (checked: boolean) => void
  isTermsAndConditionsChecked: boolean
}

interface StyleProps {
  isChecked: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  checkbox: { padding: 0, marginRight: theme.spacing(2) },
  inlineContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  normalText: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.grey.grey03,
  },
  termsOfServiceText: {
    color: props.isChecked ? theme.palette.primary.main : theme.palette.error.main,
    borderColor: theme.palette.grey.grey03,
  },
}))

/*
 * This component shows text data at checkout to inform user about TOS, Agreements and Policies.
 */
const ConfirmCheckoutInformation: React.FC<ConfirmCheckoutInformationProps> = ({ isTermsAndConditionsChecked, onChangeTermsAndConditions }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles({ isChecked: isTermsAndConditionsChecked })
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h2" className={classes.normalText}>
          {t('shop.confirm-checkout.check-and-order')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h2" sx={{ fontWeight: 400 }} className={classes.normalText}>
          {t('shop.confirm-checkout.terms-and-conditions')}
        </Typography>
        <Divider className={classes.normalText} variant="fullWidth" />
      </Grid>
      <Grid item xs={12}>
        <Box className={classes.inlineContainer}>
          <Checkbox
            required={true}
            className={classes.checkbox}
            onChange={event => {
              onChangeTermsAndConditions(event.target.checked ?? false)
            }}
          />
          <a href="https://my.e3dc.com/shop/terms-and-conditions" target={'_blank'} rel={'noreferrer'} className={classes.termsOfServiceText}>
            {t('shop.confirm-checkout.terms-and-conditions-agree')}
          </a>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4" className={classes.normalText}>
          {t('shop.confirm-checkout.cancellation-policy')}
        </Typography>
      </Grid>
    </>
  )
}

export default ConfirmCheckoutInformation
